import { atom } from 'jotai'

export const dirtyCommentCountAtom = atom(0)
